import Toolbar from "components/Toolbar";
import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import BusinessRegistration from "./registration_type/BusinessRegistration";
import IndividualRegistration from "./registration_type/IndividualRegistration";

function Register() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const prefilled = location.state?.prefilledFields;
  const [tab, setTab] = useState(1);

  useEffect(() => {
    if (user !== null) {
      navigate("/dashboard");
    }
  }, [user, navigate]);

  return (
    <>
      <div className="flex justify-center grid grid-cols-2 items-center w-full h-screen no-scrollbar">
        <div className="hidden md:flex col-span-1 h-full bg-primary justify-center items-center">
          <div>
            <img className="h-[5rem] cursor-pointer" src="images/whitelogo.svg" alt="LOGO" />
          </div>
        </div>
        <div className="w-full md:ml-1/2 col-span-2 md:col-span-1 h-screen overflow-auto flex flex-col items-center justify-start">
          <Toolbar
            title={t("O_REGISTER_TAB")}
            showBackBtn={true}
            forceTitleCenter={true}
            forceShowBack={true}
            overrideBack={() => {
              navigate("/login");
            }}
          />
          <h3 className="text-center font-medium text-lg">{t("SELECT_YOUR_ACCOUNT_TYPE")}</h3>
          <div className="flex w-full justify-center gap-3 mt-5 px-5">
            <button
              className={`${tab === 1 ? "btn bg-primary" : "bg-card"} text-white font-medium w-full md:w-[10rem]`}
              onClick={() => {
                setTab(1);
              }}
            >
              {t("INDIVIDUAL")}
            </button>
            <button
              className={`${tab === 2 ? "btn bg-primary" : "bg-card"} text-white font-medium w-full md:w-[10rem]`}
              onClick={() => {
                setTab(2);
              }}
            >
              {t("MERCHANT")}
            </button>
          </div>
          {tab === 1 && (
            <div className="mt-5">
              <IndividualRegistration prefilledFields={prefilled} />
            </div>
          )}

          {tab === 2 && (
            <div className="mt-5">
              <BusinessRegistration prefilledFields={prefilled} />
            </div>
          )}

        </div>
      </div>
    </>
  );
}

export default Register;
